import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "2c53716e-dc8b-4fca-ac4f-8c8b862da230",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    orientation: "vertical",
    type: "number",
    prefixText: "Input numerical answer",
    unit: "V",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 1.5,
};
